import React, { useMemo } from 'react'

import { Navigate, Outlet, useLocation } from 'react-router'

import { useAuth } from '@/hooks'

type TCountryGuardProps = {
  children?: React.ReactNode
}

export const CountryGuard: React.FC<TCountryGuardProps> = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()

  const userLocalidade = useMemo(() => user?.localidade ?? 'pt-BR', [user?.localidade])
  const pathname = location.pathname.toLowerCase()
  const canAccess =
    userLocalidade === 'pt-BR'
      ? !pathname.startsWith('/es-cl')
      : pathname.startsWith(`/${userLocalidade.toLowerCase()}`)

  if (!canAccess) {
    return <Navigate to={`${userLocalidade === 'pt-BR' ? '/' : '/es-CL'}`} replace />
  }

  if (children) {
    return <>{children}</>
  }

  return <Outlet />
}
